import { useEffect, useRef, type ReactNode } from "react";

/** One sign-in screen. The heading takes focus so screen readers announce each step. */
export function Screen(props: {
  readonly title: string;
  readonly body?: string;
  readonly children?: ReactNode;
  readonly footer?: ReactNode;
}) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, [props.title]);
  return (
    <main className="auth-screen">
      <section className="auth-card">
        <h1 className="auth-title" tabIndex={-1} ref={heading}>
          {props.title}
        </h1>
        {props.body === undefined ? null : <p className="auth-body">{props.body}</p>}
        {props.children}
      </section>
      {props.footer === undefined ? null : <footer className="auth-footer">{props.footer}</footer>}
    </main>
  );
}

export function Message(props: {
  readonly text: string | undefined;
  readonly tone?: "info" | undefined;
}) {
  if (props.text === undefined) return null;
  return (
    <p
      className={props.tone === "info" ? "auth-message auth-message-info" : "auth-message"}
      role={props.tone === "info" ? "status" : "alert"}
    >
      {props.text}
    </p>
  );
}
